import React from 'react'
import Forms from '../components/Forms'


export default function ContactForm(props) {
  return (
    <>
      <section className="contactForm">
    <div className="container">
        <div className="row justify-content-center">
            <div className="col-12 col-md-6">
                <div className="subContact">
                    <h2>Connect With Us</h2>
                    <Forms submitBtnName="Connect Now" formsource="Footer Form"/>
                </div>
            </div>
        </div>
    </div>
</section>
    </>
  )
}
